import BlueGradientLayout from '../../layouts/BlueGradientLayout';
import ErrorContainer from '../../components/ErrorContainer';
import { FC } from 'react';

type TNotAvailableProps = {
  resetError: VoidFunction;
};

const NotAvailable: FC<TNotAvailableProps> = ({ resetError }) => {
  return (
    <div className="base-page">
      <BlueGradientLayout>
        <ErrorContainer resetError={resetError} />
      </BlueGradientLayout>
    </div>
  );
};

export default NotAvailable;
